// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconBin = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 13,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-bin">
      <svg width={width || measurements.width} height={height || measurements.height} viewBox="0 0 13 16" className="c-icon-bin fill-current" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.7248 2.19999H8.7998V1.77499C8.7998 1.02499 8.1998 0.424988 7.4498 0.424988H5.52481C4.77481 0.424988 4.1748 1.02499 4.1748 1.77499V2.19999H2.2498C1.5248 2.19999 0.924805 2.79999 0.924805 3.52499V4.27499C0.924805 4.82499 1.2498 5.27499 1.7248 5.47499L2.1248 13.75C2.1748 14.775 3.02481 15.575 4.0498 15.575H8.8998C9.9248 15.575 10.7748 14.775 10.8248 13.75L11.2498 5.44999C11.7248 5.24999 12.0498 4.77499 12.0498 4.24999V3.49999C12.0498 2.79999 11.4498 2.19999 10.7248 2.19999ZM5.3248 1.77499C5.3248 1.64999 5.4248 1.54999 5.5498 1.54999H7.4748C7.5998 1.54999 7.6998 1.64999 7.6998 1.77499V2.19999H5.3498V1.77499H5.3248ZM2.0748 3.52499C2.0748 3.42499 2.1498 3.32499 2.2748 3.32499H10.7248C10.8248 3.32499 10.9248 3.39999 10.9248 3.52499V4.27499C10.9248 4.37499 10.8498 4.47499 10.7248 4.47499H2.2748C2.1748 4.47499 2.0748 4.39999 2.0748 4.27499V3.52499ZM8.9248 14.45H4.0748C3.6498 14.45 3.2998 14.125 3.2748 13.675L2.8998 5.57499H10.1248L9.7498 13.675C9.6998 14.1 9.3498 14.45 8.9248 14.45Z" fill={fill || 'inherit'} />
        <path d="M6.4998 8.09998C6.1998 8.09998 5.9248 8.34998 5.9248 8.67498V11.85C5.9248 12.15 6.1748 12.425 6.4998 12.425C6.7998 12.425 7.0748 12.175 7.0748 11.85V8.67498C7.0748 8.34998 6.7998 8.09998 6.4998 8.09998Z" fill={fill || 'inherit'} />
        <path d="M8.49994 8.59998C8.17494 8.57498 7.92494 8.79998 7.89994 9.12498L7.74994 11.325C7.72494 11.625 7.94994 11.9 8.27494 11.925C8.29994 11.925 8.29994 11.925 8.32494 11.925C8.62494 11.925 8.87494 11.7 8.87494 11.4L9.02494 9.19998C9.02494 8.87498 8.79994 8.62498 8.49994 8.59998Z" fill={fill || 'inherit'} />
        <path d="M4.47497 8.59998C4.17497 8.62498 3.92497 8.89998 3.94997 9.19998L4.12497 11.4C4.14997 11.7 4.39997 11.925 4.67497 11.925C4.69997 11.925 4.69997 11.925 4.72497 11.925C5.02497 11.9 5.27497 11.625 5.24997 11.325L5.07497 9.12498C5.07497 8.79998 4.79997 8.57498 4.47497 8.59998Z" fill={fill || 'inherit'} />
      </svg>

    </Icon>
  );
};

export default IconBin;
